import { Component, computed, input, model, OnInit, output } from '@angular/core';
import { PaperSizeType } from '../../../models/server-models/enums/paper-size-type';
import { ExpandedPaperSize } from '../../../models/client-models/entities/expanded-paper-size';

@Component({
  selector: 'app-paper-size-selection',
  templateUrl: './paper-size-selection.component.html',
  styleUrls: ['./paper-size-selection.component.scss'],
  standalone: false,
})
export class PaperSizeSelectionComponent implements OnInit {
  paperSizeType = PaperSizeType;

  paperSizes = input.required<ExpandedPaperSize[]>();
  selectedPaperSize = model<ExpandedPaperSize | null>(null);
  selectedPaperSizeType = computed(() => this.selectedPaperSize()?.type);

  doNextStep = output<void>();

  constructor() {}

  ngOnInit() {}

  onPaperSizeClick(paperSize: ExpandedPaperSize) {
    this.selectedPaperSize.set(paperSize);
  }

  onPaperSizeBoxClick(paperSizeType: PaperSizeType) {
    const paperSize = this.paperSizes().find((x) => x.type === paperSizeType);

    if (paperSize) {
      this.selectedPaperSize.set(paperSize);
    }
  }

  onDoubleClick() {
    this.doNextStep.emit();
  }
}
